import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MarkerDataService } from 'src/app/shared/service/makerservice/markerDataService';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-public-dashboard',
  templateUrl: './public-dashboard.component.html',
  styleUrl: './public-dashboard.component.scss'
})
export class PublicDashboardComponent {
  centreItems: any = [];
  ArticlePdcItems: any = [];
  motDumaireItems: any = {};
  isLoading: boolean = true;
  loading: boolean = true;
  loadingMotDumaire: boolean = true;
  zoneSlideItems:any = [];

  constructor(

    private router: Router,
    private paramService: ParameterService,
    private localStorage: LocalStorageService,
    private markerDataService: MarkerDataService,
  ) {


  }


  ngOnInit() {

    this.getSlideZoneArticle();
    //  this.getRessource();

  }





  goToDetailProjet(item: any): void {
    this.localStorage.saveAccueil(item)
    this.router.navigate(['/projet', item.reference]);

  }


  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/default.jpg';
  }

  mayorImage:any;
  mayorName:any;
  mayorMessage:any;


  getSlideZoneArticle(){
    this.paramService.getSlideZoneArticle().subscribe(
      (response:any)=>{
        this.zoneSlideItems = response.data;
        this.getArticlePdc();
        console.log("la réponse du webservice",response);
        
      },
      (error:any)=>{
        console.log("une erreur est survenu",error);
        
      }
    )
  }


  getArticlePdc() {
    this.loading = true;

    this.paramService.getPdc().subscribe(
      (response: any) => {
        this.ArticlePdcItems = response.data;
        this.loading = false;
        this.getMotDuMaire();
      },
      (error) => {
        this.loading = false;
      }
    );
  }

    getMotDuMaire() {
    this.loadingMotDumaire = true;
    this.paramService.getMotDumaire().subscribe(
      (response: any) => {
        this.motDumaireItems = response.data;
        this.mayorImage = this.motDumaireItems.mayor_image.value;
        this.mayorName = this.motDumaireItems.mayor_name.value;
        this.mayorMessage = this.motDumaireItems.mayor_message.value;
       // console.log(" this.mayorImage", this.mayorImage);
        
          
        this.loadingMotDumaire = false;

        // console.log('la reponse du webservice', response.data);

      },
      (error: any) => {
        this.isLoading = false;

        //    console.log('une erreur est survenu', error);
      }
    )
  }




imagesLoaded: boolean[] = [];

onImageLoad(index: number): void {
  this.imagesLoaded[index] = true;
}

onImageErrorSilde(event: Event, index: number): void {
  const img = event.target as HTMLImageElement;
  img.src = 'assets/images/PalaisRoyalParakou.jpg';
  this.imagesLoaded[index] = true;
}


}
